/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Tab_AllInputs */

const en_admin_payments_tab_all = /** @type {(inputs: Admin_Payments_Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Admin_Payments_Tab_AllInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_tab_all = /** @type {((inputs?: Admin_Payments_Tab_AllInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Tab_AllInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_tab_all(inputs)
});
export { admin_payments_tab_all as "admin.payments.tab_all" }